import { csx } from '@vtex/admin-ui'
import { TextArea } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { enforce, test } from 'vest'
import { ValidationFn, useFormValidation } from '../../../providers'
import { useFormStateContext } from '../../../providers/FormStateContext'

interface Props {
  name: string
  length?: number
}

function validateFunction(
  fieldName: string,
  length: number
): ValidationFn<string> {
  return function (value, { intl: { formatMessage } }) {
    test(
      fieldName,
      formatMessage(
        { id: 'admin/promotions.form.validation.max-length' },
        { length }
      ),
      () => {
        enforce(value).shorterThanOrEquals(length)
      }
    )
  }
}

export function DescriptionInput(props: Props) {
  const { name, length = LIMITS.MAX_DESCRIPTION_LENGTH } = props
  const { formatMessage } = useIntl()
  const { form, readOnly } = useFormStateContext()

  useFormValidation<string>('promotion-description', {
    fieldName: name,
    validateFn: validateFunction(name, length),
  })

  return (
    <div className={csx({ marginBottom: -8 })}>
      <TextArea
        name={name}
        // @ts-expect-error Property 'disabled' does not exist on type 'IntrinsicAttributes & InheritedProps$6 & FormFieldProps' (typings error)
        disabled={readOnly}
        label={formatMessage({
          id: 'admin/promotions.form.general.description',
        })}
        state={form}
        maxLength={length}
        onKeyDown={(e) => e.stopPropagation()}
      />
    </div>
  )
}
